import { Route } from 'react-router'
import { CraEmptyStepPage } from './CraEmptyStepPage'
import { CraIntroductionPage } from './CraIntroductionPage'
import { CraRiskAssessmentPage } from './CraRiskAssessmentPage'
import { CraStudioPage } from './CraStudioPage'
import { CraUserInformationPage } from './CraUserInformationPage'

export const craStudioRoute = (
  <Route
    path='product-catalog/:productId/cra/:craStudioId'
    element={<CraStudioPage />}
  >
    <Route index element={<CraIntroductionPage />} />
    <Route
      path='standards'
      element={
        <CraEmptyStepPage
          titleKey='standardsPage.title'
          descriptionKey='standardsPage.emptyStateMessage'
          buttonKeys={['standardsPage.checkApplicability']}
        />
      }
    />
    <Route
      path='machine-locations'
      element={
        <CraEmptyStepPage
          titleKey='machineLocationsPage.pageTitle'
          emptyTitleKey='machineLocationsPage.emptyTitle'
          descriptionKey='machineLocationsPage.emptyDescription'
          buttonKeys={['machineLocationsPage.addButton']}
        />
      }
    />
    <Route
      path='hazards'
      element={
        <CraEmptyStepPage
          titleKey='hazardsPage.title'
          descriptionKey='hazardsPage.emptyStateMessage'
          buttonKeys={[
            'hazardsPage.addHazard',
            'hazardsPage.generateFromStandards',
          ]}
        />
      }
    />
    <Route
      path='risk-reduction-measures'
      element={
        <CraEmptyStepPage
          titleKey='riskReductionMeasuresLibraryPage.title'
          emptyTitleKey='riskReductionMeasuresLibraryPage.emptyState.title'
          descriptionKey='riskReductionMeasuresLibraryPage.emptyState.description'
          buttonKeys={[
            'riskReductionMeasuresLibraryPage.addRiskReductionMeasure',
          ]}
        />
      }
    />
    <Route
      path='safety-functions'
      element={
        <CraEmptyStepPage
          titleKey='safetyFunctionsPage.title'
          emptyTitleKey='safetyFunctionsPage.emptyState.title'
          descriptionKey='safetyFunctionsPage.emptyState.description'
          buttonKeys={['safetyFunctionsPage.emptyState.addFirst']}
        />
      }
    />
    <Route
      path='ehsrs-overview'
      element={
        <CraEmptyStepPage
          titleKey='ehsrsOverviewPage.title'
          descriptionKey='ehsrsOverviewPage.description'
          buttonKeys={['ehsrsOverviewPage.view']}
        />
      }
    />
    <Route path='risk-assessment' element={<CraRiskAssessmentPage />} />
    <Route path='user-information' element={<CraUserInformationPage />} />
    <Route
      path='manual-generation'
      element={
        <CraEmptyStepPage
          titleKey='manualGenerationPage.title'
          descriptionKey='manualGenerationPage.emptyStateMessage'
          buttonKeys={['manualGenerationPage.generateDocument']}
        />
      }
    />
    <Route
      path='manual'
      element={
        <CraEmptyStepPage
          titleKey='nav.manual.validation'
          descriptionKey='standardsPage.manualValidationPage.noSourcesHint'
        />
      }
    />
    <Route
      path='declaration-of-conformity'
      element={
        <CraEmptyStepPage
          i18nNamespace='craCompliance'
          titleKey='nav.declarationOfConformity'
          descriptionKey='overview.steps.declarationOfConformity'
        />
      }
    />
    <Route
      path='technical-documentation'
      element={
        <CraEmptyStepPage
          i18nNamespace='craCompliance'
          titleKey='nav.technicalDocumentation'
          descriptionKey='overview.steps.technicalDocumentation'
        />
      }
    />
    <Route
      path='settings/associated-parties'
      element={
        <CraEmptyStepPage
          titleKey='settings.associatedParties.pageTitle'
          descriptionKey='settings.associatedParties.pageDescription'
          buttonKeys={['settings.associatedParties.add']}
        />
      }
    />
    <Route
      path='settings/product-metadata'
      element={
        <CraEmptyStepPage
          titleKey='settings.productMetadata.pageTitle'
          descriptionKey='settings.productMetadata.pageDescription'
        />
      }
    />
    <Route
      path='settings/e-plan'
      element={
        <CraEmptyStepPage
          titleKey='settings.ePlan.pageTitle'
          descriptionKey='settings.ePlan.pageDescription'
          buttonKeys={['settings.ePlan.assignFlow.upload']}
        />
      }
    />
  </Route>
)
